export default __webpack_public_path__ + "static/media/_payment-card.531c0ce9.svg";